import React from "react";
import VisibilityToggle from "../VisibilityToggle";
import Spacer from "../Spacer";
import Label from "../Label";
import useStyle from "./useStyle";

interface NavPromptProps {
  isVisible: boolean;
  message: string;
  iconArea?: JSX.Element | undefined;
}

const NavPrompt: React.FC<NavPromptProps> = props => {
  const classes = useStyle();

  return (
    <VisibilityToggle isVisible={props.isVisible}>
      {props.iconArea}
      <Spacer orientation="h" size="m" />
      <Label label={props.message} className={classes.message} />
    </VisibilityToggle>
  );
};

export default NavPrompt;
